const ROLES = {
    FUll_ROLES: ["td", "kt", "t", "kd", "xnk", "k"]
}
export default ROLES
